/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

Odigeo.defineWidget('dp_waiting_page', Odigeo.Widget.extend({
    modelClass: require('../modules/models/dp_waiting_page'),
    viewClass: require('../modules/views/dp_waiting_page'),

    activate: function() {
        return this.view.activateWaitingPage.apply(this.view, arguments);
    },

    deactivate: function() {
        this.view.animateWaiting(this.view.deactivateWaitingPage, this.view.getCalculatedDelay());
    },

    off: function() {
        this.view.animateWaiting(this.view.offWaitingPage, 0);
    },
}));
